import { getEditCourseListIds } from '@/request/api';

const KOUZI_ACCESS_TOKEN = 'kouzi_access_token';
const KOUZI_REFRESH_TOKEN = 'kouzi_refresh_token';

export function isCanEdit(schCourseId, canCourseIds) {
  const userRole = localStorage.getItem('userRole');
  if (userRole === 'professor') {
    return true;
  }
  if (!canCourseIds || canCourseIds.length === 0) {
    return false;
  }
  return canCourseIds.findIndex((d) => d === schCourseId) >= 0;
}

export function isCanEditV2(schCourseId) {
  const editCourseListIds = localStorage.getItem('editCourseListIds');
  if (!editCourseListIds) {
    return false;
  }
  const resData = JSON.parse(editCourseListIds);
  const canCourseIds = resData.data;
  const userRole = localStorage.getItem('userRole');
  if (userRole === 'professor') {
    return true;
  }
  if (!canCourseIds || canCourseIds.length === 0) {
    return false;
  }
  return canCourseIds.findIndex((d) => d === schCourseId) >= 0;
}

export function getUserSpecialityDeptList() {
  const strUserInfo = localStorage.getItem('userInfo');
  const userInfo = JSON.parse(strUserInfo);
  return userInfo.specialityDeptList;
}

export function getUserSpecialityDeptId() {
  let specialityDeptId = 0;
  const specialityId = localStorage.getItem('specialityId');
  if (specialityId) {
    specialityDeptId = parseInt(specialityId);
    return specialityDeptId;
  }
  const strUserInfo = localStorage.getItem('userInfo');
  if (!strUserInfo) {
    return specialityDeptId;
  }
  const userInfo = JSON.parse(strUserInfo);
  if (
    !userInfo ||
    !userInfo.specialityDeptList ||
    userInfo.specialityDeptList.length === 0
  ) {
    return specialityDeptId;
  }
  specialityDeptId = userInfo.specialityDeptList[0].id;
  return specialityDeptId;
}

export function getUserId() {
  const strUserInfo = localStorage.getItem('userInfo');
  const userInfo = JSON.parse(strUserInfo);
  return userInfo.id;
}

export function getUserJobNumber() {
  const strUserInfo = localStorage.getItem('userInfo');
  const userInfo = JSON.parse(strUserInfo);
  return userInfo.jobNumber;
}

export function getUserRole() {
  const userRole = localStorage.getItem('userRole');
  return userRole;
}

export function isTeacher() {
  const userRole = localStorage.getItem('userRole');
  return userRole === 'teacher';
}

export function isStudent() {
  const userRole = localStorage.getItem('userRole');
  return userRole === 'student';
}
/**
 * 是否教授身份
 * @returns
 */
export function isProfessor() {
  const userRole = localStorage.getItem('userRole');
  return userRole === 'professor';
}

/**
 * 是否教务处
 * @returns
 */
export function isEducationalAffairs() {
  const userRole = localStorage.getItem('userRole');
  return userRole === 'office';
}

export function isCanSeeImage() {
  return !isEducationalAffairs() && !isProfessor();
}

/**
 *
 * @returns
 */
export function schemeMenuHeight() {
  return window.innerHeight - 230;
}

/**
 *
 * @returns
 */
export function schemeTableHeight() {
  return window.innerHeight - 380;
}

/**
 *
 * @returns
 */
export function hasEditCoursePermission(courseId) {
  if (isEducationalAffairs()) {
    return true;
  }
  const strEditCourseIds = localStorage.getItem('editCourseIds');
  if (!strEditCourseIds) {
    return false;
  }
  const editCourseIds = JSON.parse(strEditCourseIds);
  if (Array.isArray(editCourseIds) === false) {
    return false;
  }
  return editCourseIds.find((d) => d === courseId) > 0;
}

export function getLocalEditCourseListIds() {
  const strEditCourseIds = localStorage.getItem('editCourseIds');
  if (!strEditCourseIds) {
    return [];
  }
  const editCourseIds = JSON.parse(strEditCourseIds);
  if (Array.isArray(editCourseIds) === false) {
    return [];
  }
  return editCourseIds;
}

export function refreshEditCourseListIds(callback) {
  getEditCourseListIds().then((res) => {
    if (res.data) {
      localStorage.setItem('editCourseIds', JSON.stringify(res.data));
    }
    typeof callback === 'function' && callback(res.data);
  });
}

export const uuid2 = (len, radix) => {
  const chars =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];
  let i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    let r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
};

export const umamiTrack = (w, action, data) => {
  const jobNumber = getUserJobNumber();
  if (data && typeof data === 'object') {
    data.IP = '';
    data.userId = jobNumber + '';
    data.visitTime = Date.now() + '';
  }
  if (w.umami) {
    w.umami.track(action, data);
  }
};

export const isEnableExplore = () => {
  const hostname = location.hostname;
  return hostname === 'localhost' || hostname === '101.200.84.209';
};

// ---------------  Access Token  ---------------
export const setKouziAccessToken = (val) =>
  localStorage.setItem(KOUZI_ACCESS_TOKEN, val);

export const getKouziAccessToken = () =>
  localStorage.getItem(KOUZI_ACCESS_TOKEN);

export const clearKouziAccessToken = () =>
  localStorage.removeItem(KOUZI_ACCESS_TOKEN);

// ---------------  Refresh Token  ---------------
export const setKouziRefreshToken = (val) =>
  localStorage.setItem(KOUZI_REFRESH_TOKEN, val);

export const getKouziRefreshToken = () =>
  localStorage.getItem(KOUZI_REFRESH_TOKEN);

export const clearKouziRefreshToken = () =>
  localStorage.removeItem(KOUZI_REFRESH_TOKEN);

export const generateUUID = () => {
  const d = new Date().getTime(); // 当前时间的毫秒数
  const d2 = (performance && performance.now && performance.now() * 1000) || 0; // 微秒级时间戳
  const id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      const r = (d + Math.random() * 16) % 16 | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
  return id;
};

export function urlParam(key) {
  return new RegExp('(^|&)' + key + '=([^(&|#)]*)').test(
    window.location.search.substring(1) + '#'
  )
    ? RegExp.$2
    : null;
}

export function getFormattedDate(date) {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  const year = date.getFullYear(); // 获取年份
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 获取月份，+1是因为getMonth()返回的月份是从0开始的
  const day = String(date.getDate()).padStart(2, '0'); // 获取日期
  return `${year}-${month}-${day}`;
}

export const getTimeRange = (rangeType) => {
  const now = new Date();
  let dateRange = null;
  switch (rangeType) {
    case 1: // 今日数据
      dateRange = {
        start: new Date(now.getFullYear(), now.getMonth(), now.getDate()),
        end: new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1),
      };
      break;
    case 2: // 近7日数据
      dateRange = {
        start: new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6),
        end: new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1),
      };
      break;
    case 3: // 近30日数据
      dateRange = {
        start: new Date(now.getFullYear(), now.getMonth(), now.getDate() - 29),
        end: new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1),
      };
      break;
  }
  if (dateRange) {
    dateRange.start = getFormattedDate(dateRange.start);
    dateRange.end = getFormattedDate(dateRange.end);
  }
  return dateRange;
};

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.\d{3}/gm),'');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  
  // 处理 'yyyy年MM月dd日' 格式
  if (pattern === 'yyyy年MM月dd日') {
    return `${formatObj.y}年${formatObj.m < 10 ? '0' + formatObj.m : formatObj.m}月${formatObj.d < 10 ? '0' + formatObj.d : formatObj.d}日`;
  }
  
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}